import { render } from "./EmployersPage.vue?vue&type=template&id=54925818&scoped=true"
import script from "./EmployersPage.vue?vue&type=script&lang=js"
export * from "./EmployersPage.vue?vue&type=script&lang=js"

import "./EmployersPage.vue?vue&type=style&index=0&id=54925818&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54925818"]])

export default __exports__